import { VALIDATION_PATTERNS, UI_CONFIG } from '../constants/config';

export const sanitizeInput = (value) => {
  return value
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<[^>]*>/g, '')
    .trim();
};

export const validateName = (value) => {
  // Name is required and must match pattern (letters, spaces, hyphens, apostrophes)
  return value.length > 0 && value.length <= UI_CONFIG.nameMaxLength && VALIDATION_PATTERNS.name.test(value);
};

export const validateEmail = (value) => {
  // Allow empty or match email pattern (no spaces allowed)
  if (value === '') return true;
  return value.length <= UI_CONFIG.emailMaxLength && !value.includes(' ') && VALIDATION_PATTERNS.email.test(value);
};

export const validatePhone = (value) => {
  return value === '' || VALIDATION_PATTERNS.phone.test(value);
};

export const validateDate = (value) => {
  if (value === '') return true;
  const selectedDate = new Date(value);
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + UI_CONFIG.minFutureDate);
  tomorrow.setHours(0, 0, 0, 0);
  return selectedDate >= tomorrow;
};

export const validatePassengers = (value, minimumPeople = 1) => {
  if (value === '') return true;
  if (!/^\d+$/.test(value) || parseInt(value) > UI_CONFIG.maxPassengers) return false;
  return parseInt(value) >= minimumPeople;
};

export const validateMessage = (value) => {
  return value.trim().length >= 5 && value.length <= UI_CONFIG.messageMaxLength;
};

export const validateInput = (name, value, minimumPeople = 1) => {
  switch (name) {
    case 'name':
      return validateName(value);
    case 'email':
      return validateEmail(value);
    case 'phone':
      return validatePhone(value);
    case 'date':
      return validateDate(value);
    case 'passengers':
      return validatePassengers(value, minimumPeople);
    case 'message':
      return validateMessage(value);
    default:
      return true;
  }
};

export const getMinPassengersError = (minimumPeople) => {
  return `This tour requires a minimum of ${minimumPeople} passengers.`;
};
